// Org grants are composable on the server: ORG_ADMIN stands alone, otherwise
// ORG_USER is the base and each management permission is an extra grant.
export const ORG_PERMISSION_LABELS = {
    ORG_TEAMS_MANAGEMENT: 'Teams Management',
    ORG_PRODUCTIVITY_MANAGEMENT: 'Productivity Management',
    ORG_DIRECT_REPORTS_MANAGER: 'Manager'
};

export const ORG_ROLE_LABELS = {
    ORG_ADMIN: 'Admin',
    ORG_USER: 'User'
};

// Form switches -> API payload. An admin already holds every permission, so
// the other switches (which keep their last value in form state) are dropped.
export function buildOrgRolePayload({ orgAdmin, orgTeamsManagement, orgProductivityManagement, orgDirectReportsManager }) {
    if (orgAdmin) {
        return { orgRole: 'ORG_ADMIN', orgPermissions: [] };
    }
    const orgPermissions = [];
    if (orgTeamsManagement) {
        orgPermissions.push('ORG_TEAMS_MANAGEMENT');
    }
    if (orgProductivityManagement) {
        orgPermissions.push('ORG_PRODUCTIVITY_MANAGEMENT');
    }
    if (orgDirectReportsManager) {
        orgPermissions.push('ORG_DIRECT_REPORTS_MANAGER');
    }
    return { orgRole: 'ORG_USER', orgPermissions };
}

// Granted role names (user detail's orgGrants) -> form switches
export function orgOptionsFromGrants(grants) {
    return {
        orgAdmin: grants.includes('ORG_ADMIN'),
        orgTeamsManagement: grants.includes('ORG_TEAMS_MANAGEMENT'),
        orgProductivityManagement: grants.includes('ORG_PRODUCTIVITY_MANAGEMENT'),
        orgDirectReportsManager: grants.includes('ORG_DIRECT_REPORTS_MANAGER')
    };
}
